"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// @ts-ignore
var steamer_net_1 = __importDefault(require("steamer-net"));
var constants_1 = require("./constants");
var dui_mobile_1 = require("@tencent/dui-mobile");
var utils_1 = require("./utils");
var WxH5ToMiniProgramBtn = /** @class */ (function (_super) {
    __extends(WxH5ToMiniProgramBtn, _super);
    function WxH5ToMiniProgramBtn(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var _a = _this.props, debug = _a.debug, destinationUrl = _a.destinationUrl;
            var _b = _this.state, height = _b.height, width = _b.width;
            var wxTagStyle = {
                background: debug ? 'red' : 'transparent',
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
            };
            // 由于button是镶嵌在微信标签内部的script中，不能通过定位父组件的方式进行样式扩充
            var hiddenButtonStyle = {
                height: height,
                width: width,
                opacity: Number(debug),
            };
            return (
            /** 引用跳转标签，这里的代码轻易不要改变，如果要重构(包括样式)一定要问问rickgao或者okamiwang */
            /* @ts-ignore */
            react_1.default.createElement("wx-open-launch-weapp", { id: "wx-mini-launch-btn_" + _this.randomKey, username: constants_1.TENCENT_DOCS_MINI_PROGRAM_ORIGINAL_ID, path: destinationUrl, style: wxTagStyle },
                react_1.default.createElement("script", { type: "text/wxtag-template" },
                    react_1.default.createElement("button", { style: hiddenButtonStyle }))));
        };
        /**
         * 判断是否已经加载过WxSDK
         * @returns 返回boolean，表示是否加载过WxSDK
         */
        _this.isWxSDKInitialized = function () { return !!(window.wx && _this.wxInstance); };
        /**
         * 用于兼容IE浏览器，在IE环境下，判断script是否被加载到当前HTML中
         * 判断成功条件：
         *  1）readyState为loaded
         *  2）readyState为complete
         *  3）无readyState属性
         * @param scriptDom script的DOM节点
         * @returns 返回boolean，表示script是否已进入HTML中
         */
        _this.isIEScriptDOMLoaded = function (scriptDom) { return !scriptDom.readyState || scriptDom.readyState === 'loaded' || scriptDom.readyState === 'complete'; };
        /**
         * 加载微信SDK，加载成功resolve回true，加载失败reject回失败信息
         * @returns 返回包含上述信息的Promise
         */
        _this.loadWxSDK = function () { return new Promise(function (resolve, reject) { return _this.initializeWxSdk(resolve, reject); }); };
        /**
         * @param resolve Promise resolve
         * @param reject Promise reject
         * @param hadRetry 重试次数，目前设置script加载失败后重试次数为3次
         * @returns
         */
        _this.initializeWxSdk = function (resolve, reject, hadRetry) {
            if (hadRetry === void 0) { hadRetry = 0; }
            /** window上已经挂有微信api，无需再次加载 */
            if (window.wx) {
                _this.alertInDebugMode('[WxH5ToMiniProgram] WX SDK has already been loaded!');
                resolve(true);
                return;
            }
            /** 加载微信api */
            _this.alertInDebugMode('[WxH5ToMiniProgram] WX SDK has not been initialized, now create it!');
            // 创建script
            var scriptDom = document.createElement('script');
            scriptDom.id = constants_1.WX_JS_SDK_VERSION_ID;
            scriptDom.src = constants_1.WS_JS_SDK_LINK;
            document.head.appendChild(scriptDom);
            // 若加载失败，重试加载过程，最多尝试三次
            var eMsg = '[WxH5ToMiniProgram] Cannot initialized WX SDK';
            scriptDom.onload = function () {
                if (!_this.isWxSDKInitialized() && _this.isIEScriptDOMLoaded(scriptDom)) {
                    _this.alertInDebugMode('[WxH5ToMiniProgram] wx-js-sdk 加载成功');
                    resolve(true);
                }
                else if (hadRetry < constants_1.WX_SDK_RETRY_TIME) {
                    _this.initializeWxSdk(resolve, reject, hadRetry + 1);
                }
                else {
                    _this.alertInDebugMode(eMsg + "(\u5C1D\u8BD5" + hadRetry + "\u6B21\uFF0C\u5747\u5931\u8D25):");
                    reject(eMsg);
                }
            };
            scriptDom.onreadystatechange = scriptDom.onload;
            scriptDom.onerror = function () {
                scriptDom.parentNode.removeChild(scriptDom);
                if (hadRetry < constants_1.WX_SDK_RETRY_TIME) {
                    _this.initializeWxSdk(resolve, reject, hadRetry + 1);
                }
                else {
                    _this.alertInDebugMode(eMsg + "(\u5C1D\u8BD5" + hadRetry + "\u6B21\uFF0C\u5747\u5931\u8D25):");
                    reject(eMsg);
                }
            };
        };
        /**
         * 在Debug环境下，开启alert模式
         * @param msg alert输入信息
         */
        _this.alertInDebugMode = function (msg) {
            _this.props.debug && window.alert(msg);
        };
        /**
         * 开始跳转小程序注册过程
         * @param data 验证成功后返回的回调参数data
         */
        _this.startMiniProgramNavigating = function (data) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = _this.props).reportTdwWhenExp) === null || _b === void 0 ? void 0 : _b.call(_a);
            var wx = window.wx;
            _this.wxInstance = wx;
            var configs = {
                beta: true,
                debug: !!_this.props.debug,
                appId: constants_1.TENCENT_DOCS_OFFICIAL_ACCOUNT_APP_ID,
                timestamp: data.timestamp.toString(),
                nonceStr: data.noncestr.toString(),
                signature: data.signature.toString(),
                jsApiList: [constants_1.JS_API_INVOKE_MINI_PROGRAM],
                openTagList: [constants_1.WE_APP_OPEN_TAG],
            };
            try {
                (_c = _this.wxInstance) === null || _c === void 0 ? void 0 : _c.config(configs);
                (_d = _this.wxInstance) === null || _d === void 0 ? void 0 : _d.ready(_this.wxConfigSuccessCb);
                (_e = _this.wxInstance) === null || _e === void 0 ? void 0 : _e.error(_this.wxConfigFailCb);
            }
            catch (e) {
                utils_1.reportInfo('~~很有可能是wx-js-sdk版本的问题', e);
            }
        };
        /**
         * 跳转小程序验证成功后的回调，WxSdk已经load且跳转小程序验证成功
         */
        _this.wxConfigSuccessCb = function () {
            _this.alertInDebugMode('[WxH5ToMiniProgram] 跳转小程序验证 ready');
            var btn = document.getElementById("wx-mini-launch-btn_" + _this.randomKey);
            btn === null || btn === void 0 ? void 0 : btn.addEventListener('launch', function (e) {
                var _a, _b;
                (_b = (_a = _this.props).reportTdwWhenClk) === null || _b === void 0 ? void 0 : _b.call(_a);
                utils_1.reportInfo('[WxH5ToMiniProgram] 跳转小程序button ready', e);
            });
            btn === null || btn === void 0 ? void 0 : btn.addEventListener('error', function (e) {
                utils_1.reportError('[WxH5ToMiniProgram] 跳转小程序button error', e);
                dui_mobile_1.Toast.show({
                    content: '跳转小程序验证失败，请刷新页面后重试',
                    position: 'bottom',
                });
            });
        };
        /**
         * 跳转小程序验证失败后的回调
         * @param e 错误信息Event
         */
        _this.wxConfigFailCb = function (e) {
            _this.alertInDebugMode('[WxH5ToMiniProgram] 跳转小程序验证 fail');
            // config信息验证失败会执行error函数，如签名过期导致验证失败
            utils_1.reportInfo('[WxH5ToMiniProgram] 跳转小程序验证 fail', e);
        };
        _this.url = _this.props.currentUrl
            ? _this.props.currentUrl.split('#')[0]
            : window.location.href.split('#')[0];
        _this.state = {
            height: constants_1.DEFAULT_HEIGHT,
            width: constants_1.DEFAULT_WIDTH,
        };
        _this.randomKey = utils_1.getRandomKey();
        return _this;
    }
    WxH5ToMiniProgramBtn.prototype.componentDidMount = function () {
        var _this = this;
        var _a, _b;
        var siblingRef = this.props.siblingRef;
        var siblingHeight = ((_a = siblingRef === null || siblingRef === void 0 ? void 0 : siblingRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || constants_1.DEFAULT_HEIGHT;
        var siblingWidth = ((_b = siblingRef === null || siblingRef === void 0 ? void 0 : siblingRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || constants_1.DEFAULT_WIDTH;
        this.setState({
            height: siblingHeight,
            width: siblingWidth,
        });
        var url = constants_1.WX_SIGNATURE_URI + "?url=" + encodeURIComponent(this.url);
        var param = {
            padId: this.props.globalPadId,
            xsrf: utils_1.getXsrf(),
        };
        var success = function (res) {
            if (res && res.retcode === 0) {
                _this.alertInDebugMode('[WxH5ToMiniProgram] registration successful');
                _this.startMiniProgramNavigating(res);
            }
        };
        var error = function () {
            _this.alertInDebugMode('[WxH5ToMiniProgram] registration failed');
        };
        // 加载WX JSSDK并实例化微信API
        this.loadWxSDK()
            .then(function () {
            // @ts-ignore
            steamer_net_1.default.ajax({ url: url, param: param, ajaxType: 'GET', success: success, error: error });
        })
            .catch(function (e) {
            utils_1.reportError('[WxH5ToMiniProgram] loadSdk failed:', e);
        });
    };
    return WxH5ToMiniProgramBtn;
}(react_1.Component));
exports.default = WxH5ToMiniProgramBtn;
